/**
 * 70mm IMAX locator landing-page content.
 *
 * GENERATED from the UX prototype (claude.ai/design handoff "The Odyssey 70mm
 * IMAX locator") with copy from the approved page outline. US venues per the
 * StatsPanda true-70mm list; Canada per IMAX's participating-theater list;
 * coordinates from the prototype's map dataset. Every Wanderu trip link targets an active
 * city in MAMMOTH.REPORT.DIM_CITY, so a theater outside one links to its transit
 * area instead: Dublin CA to Pleasanton, Buford GA to Atlanta, Langley and
 * Richmond BC to Vancouver. data.test.ts is the integrity contract.
 *
 * Array order is the default render order for visitors without an origin
 * (theater-locator.tsx returns it unsorted), so it runs biggest metros first:
 * US by metro size, then Canada.
 */
import type { FaqItem, NowShowing, Theater } from './types'

/** Screen counts as of the July 2026 release (accuracy brief — use verbatim). */
export const screenCounts = { us: 25, canada: 9, northAmerica: 34 }

export const theaters: Theater[] = [
    {
        id: 'lincoln-square',
        name: 'AMC Lincoln Square 13 & IMAX',
        city: 'New York, NY',
        address: '1998 Broadway',
        country: 'US',
        lat: 40.775169,
        lng: -73.98187,
        ticketsUrl:
            'https://www.amctheatres.com/movie-theatres/new-york-city/amc-lincoln-square-13',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ny/new-york/',
    },
    {
        id: 'tcl-chinese',
        name: 'TCL Chinese Theatre IMAX',
        city: 'Hollywood, CA',
        address: '6925 Hollywood Blvd',
        country: 'US',
        lat: 34.102086,
        lng: -118.340961,
        ticketsUrl: 'https://www.tclchinesetheatres.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/los-angeles/',
    },
    {
        id: 'citywalk',
        name: 'Universal Cinema AMC at CityWalk & IMAX',
        city: 'Universal City, CA',
        address: '100 Universal City Plaza',
        country: 'US',
        lat: 34.137031,
        lng: -118.35261,
        ticketsUrl: 'https://www.amctheatres.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/los-angeles/',
    },
    {
        id: 'la-live',
        name: 'Regal LA Live & IMAX',
        city: 'Los Angeles, CA',
        address: '1000 W Olympic Blvd',
        country: 'US',
        lat: 34.04592,
        lng: -118.26733,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/los-angeles/',
    },
    {
        id: 'irvine-spectrum',
        name: 'Regal Irvine Spectrum & IMAX',
        city: 'Irvine, CA',
        address: '500 Spectrum Center Dr',
        country: 'US',
        lat: 33.651688,
        lng: -117.74507,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/irvine/',
    },
    {
        id: 'ontario-palace',
        name: 'Regal Edwards Ontario Palace & IMAX',
        city: 'Ontario, CA',
        address: '4900 E 4th St',
        country: 'US',
        lat: 34.075735,
        lng: -117.548838,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/ontario/',
    },
    {
        id: 'seven-bridges',
        name: 'Cinemark Seven Bridges & IMAX',
        city: 'Woodridge, IL',
        address: '6500 IL-53',
        country: 'US',
        lat: 41.767463,
        lng: -88.07029,
        ticketsUrl: 'https://www.cinemark.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-il/chicago/',
    },
    {
        id: 'cinemark-dallas',
        name: 'Cinemark Dallas XD & IMAX',
        city: 'Dallas, TX',
        address: '11819 Webb Chapel Rd',
        country: 'US',
        lat: 32.909946,
        lng: -96.872411,
        ticketsUrl: 'https://www.cinemark.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-tx/dallas/',
    },
    {
        id: 'metreon',
        name: 'AMC Metreon 16 & IMAX',
        city: 'San Francisco, CA',
        address: '135 4th St',
        country: 'US',
        lat: 37.784341,
        lng: -122.403405,
        ticketsUrl: 'https://www.amctheatres.com/movie-theatres/san-francisco/amc-metreon-16',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/san-francisco/',
    },
    {
        id: 'hacienda-crossings',
        name: 'Regal Hacienda Crossings & IMAX',
        city: 'Dublin, CA',
        address: '5000 Dublin Blvd',
        country: 'US',
        lat: 37.703013,
        lng: -121.885639,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/pleasanton/',
    },
    {
        id: 'king-of-prussia',
        name: 'Regal UA King of Prussia & IMAX',
        city: 'King of Prussia, PA',
        address: '300 Goddard Blvd',
        country: 'US',
        lat: 40.092576,
        lng: -75.397716,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-pa/king-of-prussia/',
    },
    {
        id: 'autonation',
        name: 'AutoNation IMAX — Museum of Discovery & Science',
        city: 'Fort Lauderdale, FL',
        address: '401 SW 2nd St',
        country: 'US',
        lat: 26.120822,
        lng: -80.148102,
        ticketsUrl: 'https://mods.org/autonation-imax-theater/',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-fl/fort-lauderdale/',
    },
    {
        id: 'mall-of-georgia',
        name: 'Regal Mall of Georgia & IMAX',
        city: 'Buford, GA',
        address: '3333 Buford Dr',
        country: 'US',
        lat: 34.065621,
        lng: -83.985012,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ga/atlanta/',
    },
    {
        id: 'providence-place',
        name: 'Apple Cinemas Providence Place & IMAX',
        city: 'Providence, RI',
        address: '10 Providence Pl',
        country: 'US',
        lat: 41.826865,
        lng: -71.417017,
        ticketsUrl: 'https://www.applecinemas.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ri/providence/',
    },
    {
        id: 'tinseltown-rochester',
        name: 'Cinemark Tinseltown Rochester & IMAX',
        city: 'Rochester, NY',
        address: '2291 Buffalo Rd',
        country: 'US',
        lat: 43.147123,
        lng: -77.710516,
        ticketsUrl: 'https://www.cinemark.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ny/rochester/',
    },
    {
        id: 'rivercenter',
        name: 'AMC Rivercenter 11 & IMAX',
        city: 'San Antonio, TX',
        address: '849 E Commerce St',
        country: 'US',
        lat: 29.424611,
        lng: -98.484946,
        ticketsUrl: 'https://www.amctheatres.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-tx/san-antonio/',
    },
    {
        id: 'brenden-palms',
        name: 'Brenden Theatres at the Palms & IMAX',
        city: 'Las Vegas, NV',
        address: '4321 W Flamingo Rd',
        country: 'US',
        lat: 36.1145,
        lng: -115.196095,
        ticketsUrl: 'https://www.brendentheatres.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-nv/las-vegas/',
    },
    {
        id: 'colorado-center',
        name: 'Regal UA Colorado Center & IMAX',
        city: 'Denver, CO',
        address: '2000 S Colorado Blvd',
        country: 'US',
        lat: 39.680782,
        lng: -104.939101,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-co/denver/',
    },
    {
        id: 'carefree-circle',
        name: 'Cinemark Carefree Circle & IMAX',
        city: 'Colorado Springs, CO',
        address: '3305 Cinema Pt',
        country: 'US',
        lat: 38.880878,
        lng: -104.716095,
        ticketsUrl: 'https://www.cinemark.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-co/colorado-springs/',
    },
    {
        id: 'harkins-tempe',
        name: 'Harkins Arizona Mills 18 & IMAX',
        city: 'Tempe, AZ',
        address: '5000 S Arizona Mills Cir',
        country: 'US',
        lat: 33.383063,
        lng: -111.964348,
        ticketsUrl: 'https://www.harkins.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-az/tempe/',
    },
    {
        id: 'esquire',
        name: 'Esquire IMAX Theatre',
        city: 'Sacramento, CA',
        address: '1211 K St',
        country: 'US',
        lat: 38.578369,
        lng: -121.49025,
        ticketsUrl: 'https://www.imax.com/theatre/esquire-imax-theatre',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-ca/sacramento/',
    },
    {
        id: 'opry-mills',
        name: 'Regal Opry Mills & IMAX',
        city: 'Nashville, TN',
        address: '433 Opry Mills Dr',
        country: 'US',
        lat: 36.206018,
        lng: -86.695209,
        ticketsUrl: 'https://www.regmovies.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-tn/nashville/',
    },
    {
        id: 'tn-aquarium',
        name: 'IMAX — Tennessee Aquarium',
        city: 'Chattanooga, TN',
        address: '1 Broad St',
        country: 'US',
        lat: 35.05437,
        lng: -85.31237,
        ticketsUrl: 'https://www.tnaqua.org/imax',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-tn/chattanooga/',
    },
    {
        id: 'indiana-state',
        name: 'IMAX — Indiana State Museum',
        city: 'Indianapolis, IN',
        address: '650 W Washington St',
        country: 'US',
        lat: 39.768797,
        lng: -86.169489,
        ticketsUrl: 'https://www.imax.com/theatre/imax-indiana-state-museum',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-in/indianapolis/',
    },
    {
        id: 'celebration-gr',
        name: 'Celebration Cinema Grand Rapids North & IMAX',
        city: 'Grand Rapids, MI',
        address: '2121 Celebration Dr NE',
        country: 'US',
        lat: 43.001179,
        lng: -85.593399,
        ticketsUrl: 'https://celebrationcinema.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/us-mi/grand-rapids/',
    },
    {
        id: 'mississauga',
        name: 'Cineplex Cinemas Mississauga & IMAX',
        city: 'Mississauga, ON',
        address: '',
        country: 'CA',
        lat: 43.59,
        lng: -79.6441,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-on/mississauga/',
    },
    {
        id: 'vaughan',
        name: 'Cineplex Cinemas Vaughan & IMAX',
        city: 'Vaughan, ON',
        address: '',
        country: 'CA',
        lat: 43.7797,
        lng: -79.5273,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-on/toronto/',
    },
    {
        id: 'banque-scotia',
        name: 'Cinéma Banque Scotia Montréal & IMAX',
        city: 'Montréal, QC',
        address: '',
        country: 'CA',
        lat: 45.5088,
        lng: -73.5715,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-qc/montreal/',
    },
    {
        id: 'langley',
        name: 'Cineplex Cinemas Langley & IMAX',
        city: 'Langley, BC',
        address: '',
        country: 'CA',
        lat: 49.1044,
        lng: -122.6603,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-bc/vancouver/',
    },
    {
        id: 'riverport',
        name: 'SilverCity Riverport Cinemas & IMAX',
        city: 'Richmond, BC',
        address: '',
        country: 'CA',
        lat: 49.1236,
        lng: -123.0764,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-bc/vancouver/',
    },
    {
        id: 'chinook',
        name: 'Scotiabank Chinook & IMAX',
        city: 'Calgary, AB',
        address: '',
        country: 'CA',
        lat: 50.9977,
        lng: -114.0719,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-ab/calgary/',
    },
    {
        id: 'scotiabank-edmonton',
        name: 'Scotiabank Edmonton & IMAX',
        city: 'Edmonton, AB',
        address: '',
        country: 'CA',
        lat: 53.4525,
        lng: -113.489,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-ab/edmonton/',
    },
    {
        id: 'kramer',
        name: 'Kramer IMAX at the Saskatchewan Science Centre',
        city: 'Regina, SK',
        address: '',
        country: 'CA',
        lat: 50.4396,
        lng: -104.5883,
        ticketsUrl: 'https://www.sasksciencecentre.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-sk/regina/',
    },
    {
        id: 'bayers-lake',
        name: 'Cineplex Cinemas Bayers Lake & IMAX',
        city: 'Halifax, NS',
        address: '',
        country: 'CA',
        lat: 44.642,
        lng: -63.669,
        ticketsUrl: 'https://www.cineplex.com',
        tripUrl: 'https://www.wanderu.com/en-us/bus-tickets/ca-ns/halifax/',
    },
]

/**
 * The swappable film block. A film turnover touches: filmTitle, heroMarquee,
 * bullets 1–2, the FAQ tenses (Q5/Q9/Q10), the hero sub-copy in film-hero.tsx,
 * and the Chiku film SVG.
 */
export const nowShowing: NowShowing = {
    heroMarquee: 'ON SALE NOW · DUNE: PART THREE',
    filmTitle: 'The Odyssey',
    body: "These screens run one film at a time: Project Hail Mary had the spring (at about a dozen of them), The Odyssey is playing now, with most runs extended through mid-September, and Dune: Part Three takes over in mid-December. The theater list will stay the same from film to film (unless they build a new one), but the showtimes will change. Dune's 70mm showtimes keep selling out almost as fast as theaters can release them, so it's all worth a bit of planning.",
    beforeYouBook: [
        {
            lead: 'Two films on the calendar for now.',
            text: 'The Odyssey plays through mid-September at most of these theaters. Dune: Part Three starts early 70mm screenings December 14 and 15 (a handful of theaters get the 14th), then opens wide December 18.',
        },
        {
            lead: 'December seats are already selling.',
            text: 'The latest wave of Dune: Part Three 70mm tickets sold out within minutes. It made a lot of people sad, possibly even you. Theaters have released showtimes in waves before, so a sold-out listing today is not the final word.',
        },
        {
            lead: "Sold out near you isn't sold out everywhere.",
            text: "Every theater sells on its own schedule, so you can always check another theater if your closest isn't selling. It may be a bit more of a trip, but *cough* that's why we're here.",
            linksToMap: true,
        },
    ],
    closing:
        "This is not a walk-up. A print in this format runs miles of film, gets spliced together by hand, and only a few dozen projectors on Earth can even play it. Which is a long way of saying: if you're going, get your tickets ASAP.",
}

export const faq: FaqItem[] = [
    {
        q: 'What is IMAX 70mm?',
        a: 'IMAX 70mm is the format where the movie is shot and projected on real 70mm film, run horizontally through the projector so each frame is enormous. On screen it fills a 1.43:1 frame — nearly square, floor to ceiling — instead of the wide, letterboxed rectangle you get everywhere else. That tall frame is the whole point: you see up to 40% more picture than a standard screen shows. Only a few dozen venues on Earth can project it, and 34 of them are in North America.',
    },
    {
        q: 'What is the difference between IMAX and IMAX 70mm?',
        a: 'Most theaters branded "IMAX" today are digital IMAX with Laser, projecting a 1.90:1 image — wide, bright, and sharp, but shorter than the full frame. IMAX 70mm projects real film at 1.43:1, which is noticeably taller and shows more of the shot. The number to look for is the aspect ratio, not the word "IMAX": 1.43:1 is what you came for, 1.90:1 is the wide one. Older IMAX Digital with xenon bulbs is the dimmest of the three and the least worth travelling for.',
    },
    {
        q: 'How many IMAX 70mm theaters are there?',
        a: `There are ${screenCounts.northAmerica} in North America — ${screenCounts.us} in the United States and ${screenCounts.canada} in Canada — and only a few dozen worldwide. That scarcity is why seeing a film in 70mm IMAX usually means a trip: most people in the US do not live in one of the ${screenCounts.us} metros that has a screen. California has the most with 8; several large metros, Houston among them, have none at all.`,
    },
    {
        q: 'Where can I find IMAX 70mm near me?',
        a: `Use the locator above: enter where you are starting from, or tap "use my current location," and the full list of ${screenCounts.northAmerica} real 70mm IMAX theater locations re-sorts by distance from you, closest first, with the straight-line mileage on every row. Screens are concentrated in New York, Los Angeles, San Francisco, Dallas, Las Vegas, Denver, and the Chicago and Toronto areas. If the nearest one is a few hours out, the fare link on each theater beside it prices the bus or train there.`,
    },
    {
        q: 'How far ahead should I book Dune: Part Three in 70mm IMAX?',
        a: 'Months, this time. The first 70mm showtimes went on sale back in April, eight months before the December 18 release, and the August wave sold out in minutes at the big-city screens. Theaters release more showtimes in waves, and cancellations free up seats close to show dates, so a sold-out calendar today is worth rechecking. If a specific date or a center seat matters, book the moment a new wave opens.',
    },
    {
        q: 'Is it actually sold out everywhere?',
        a: 'The best seats at the busiest screens, often yes, especially opening weeks and weekend nights. But daytime and weekday shows loosen up as the run goes on, and screens keep releasing new dates. "Sold out" usually means the show you wanted, not every show.',
    },
    {
        q: 'What matters more, the film or the aspect ratio?',
        a: 'For most people, the aspect ratio. A 1.43:1 screen gives you the tall, floor-to-ceiling frame the movie was shot for. A 1.90:1 screen is wider and shorter, so you lose the top and bottom no matter how sharp it looks. If you have to choose, the 1.43:1 is what you are chasing.',
    },
    {
        q: 'Should I wait weeks for 70mm, or just see it sooner somewhere closer?',
        a: "If there's a good screen near you, see it now. The movie is the movie, and a bright 1.90:1 laser showing is a great night out. If you love it, catch a 70mm show later when tickets loosen up. The only real reason to hold out is if a true 1.43:1 screen is genuinely within reach and you'd rather wait than settle.",
    },
    {
        q: 'Can I see any other movies in 70mm IMAX right now?',
        a: "The theaters show one 70mm film at a time. The Odyssey is the current run, playing through mid-September at most of these theaters, and Dune: Part Three takes the screens in mid-December. Project Hail Mary ran in the spring at about a dozen of these theaters; when its run ended, it left. That's the game with this format: one film at a time.",
    },
    {
        q: 'Where can I see Dune: Part Three in 70mm IMAX?',
        a: 'On these screens. The 25 US theaters running Dune: Part Three in 70mm IMAX are the same 25 in the locator above, with early screenings December 14 and 15 before the wide release on December 18. Use the locator to sort by distance from you; the fare link on each row prices the bus or train there. If your nearest screen is sold out, check the next one out. Every theater sells independently.',
    },
    {
        q: 'Where should I sit?',
        a: 'Middle of the room, a little back. The screen is enormous, and close seats make you pan your eyes around to catch everything (and do your neck no favors). Center lets you take in the whole frame at once. The good center seats go first, which is one more reason to book early.',
    },
    {
        q: 'Is it too loud? Are the dark scenes hard to see?',
        a: 'Both come up a lot. The sound is big and can hit hard in the loudest moments, though most people find it thrilling rather than painful. And yes, some of the darker, close-up stretches look murkier on film than on a bright digital screen. Neither tends to ruin the movie.',
    },
]
